import { useRef } from "react";
import ReactDOM from "react-dom";

import AdminForm from "../forms/adminForm"
import Admin2 from "../forms/admin2";
import Admin from "../forms/admin"

export default function UserNotFound({temp, token, em}){

    const formRef = useRef(null)


    const createNew = (e) => {
        e.preventDefault();

        try {    
            ReactDOM.render(<AdminForm temp={temp} token={token} em={em} />,
                formRef.current); 
            } catch(err){
                alert(err);
        }
    }

    const handleBack = (e) => {
        e.preventDefault();
        //return(<Admin />)

        try {    
            ReactDOM.render(<Admin2 token={token}  role={'cdlisAdmin'} />,
                formRef.current); 
            } catch(err){
                alert(err);
        }
            
    }

    return(
        <div id='table' ref={formRef}>
            <div id='banner-search'>
                <h4>User Email Does Not Exist </h4>
            </div>
            <center>
                <br />
                <br />
                <h3>
                    {temp.userEmail} 
                    <br /><br />
                    Not Found
                </h3>
                <br />
                <br />

            <button id = "button"
                    onClick={handleBack}
                    style={{"textAlign": "start"}}
                    className="btn btn-primary">
                New Search
            </button>
            
            <button id = "button"
                    onClick={(e)=> createNew(e)}
                    style={{"textAlign": "start"}}
                    className="btn btn-primary">
                Create User from Email
            </button>
           </center>
        </div>
    )
}